if (!global._babelPolyfill) {
  require('babel-polyfill');
}
import Promise from 'promise-polyfill';
import { uniqueId } from 'lodash';

export default class Embedwidget {
  constructor(selector) {
    this.selector = document.querySelectorAll(selector);
    this.injectIframe = this.injectIframe.bind(this);
    this.widgetConstructor = this.widgetConstructor.bind(this);
    this.widgetDivInjector = this.widgetDivInjector.bind(this);
    this.widgetlistener = this.widgetlistener.bind(this);
    this.startEmbedProcess = this.startEmbedProcess.bind(this);
    this.injectCustomCSS = this.injectCustomCSS.bind(this);
    this.widgetTrackingGIF=this.widgetTrackingGIF.bind(this);
    
  }

  startEmbedProcess (iFrameId, wtype, geographyname, geographytype, tokenid, title, displaycolumns, themecolor,styleid,period,periodtype, colors,charttype,classtype, county,usertoken) {

        this.widgetConstructor(iFrameId, `https://aculist-widget-assets.azureedge.net`, false, false, true)
          .then(this.widgetConstructor( iFrameId, wtype == 'trends' ? `https://aculist-widget-assets.azureedge.net/widgetconfiguration.js` : null, true, false))
          .then(this.widgetDivInjector( iFrameId, wtype, geographyname, geographytype, tokenid, title, displaycolumns, themecolor,styleid,period,periodtype, colors,charttype,classtype,county,usertoken ).then(this.injectCustomCSS(iFrameId,styleid)))
          .then(this.widgetConstructor( iFrameId, wtype == 'trends' ? `https://aculist-widget-assets.azureedge.net/reactmarkettrendsiframe.min.js?v=2.4` : wtype == 'kpi' ? 'https://aculist-widget-assets.azureedge.net/reactkpiiframe.min.js?v=1.2' : null, false, wtype == 'kpi' ? false : true))
  }

  
  widgetTrackingGIF(azure_object) {

    function guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    var makeRequest = function (url, method) {
 
      // Create the XHR request
      var request = new XMLHttpRequest();
  
      // Return it as a Promise
      return new Promise(function (resolve, reject) {
  
                      // Setup our listener to process compeleted requests
                      request.onreadystatechange = function () {
  
                                      // Only run if the request is complete
                                      if (request.readyState !== 4) return;
  
                                      // Process the response
                                      if (request.status >= 200 && request.status < 300) {
                                                      // If successful
                                                      resolve(request);
                                      } else {
                                                      // If failed
                                                      reject({
                                                                      status: request.status,
                                                                      statusText: request.statusText
                                                      });
                                      }
  
                      };
  
                      // Setup our HTTP request
                      request.open(method || 'GET', url, true);
  
                      // Send the request
                      request.send();
  
    
  
      });
  };
  
      /* Google Analytics Account ID like UA-1234-56 */
      var account = "UA-72779708-3";
  
      /* Random ID to prevent browser caching */
      var z = (Math.round((new Date()).getTime() / 1000)).toString();
  
      /* Object tracking Id */
      var tracking_id = typeof azure_object !== 'undefined' ? azure_object : 'untracked';
      
      /* XHR Client */
     // var xhr = new XMLHttpRequest();
  
      var viewImageURL = "https://ssl.google-analytics.com/collect?v=1&t=pageview"
      + "&dl=" + encodeURIComponent(window.parent.location.href)
      + "&dt=" + encodeURIComponent(tracking_id) + " : " + encodeURIComponent(window.parent.document.title)
      + "&tid=" + account
      + "&z=" + z
      + "&cid=" + guid()
      + "&ea=" + window.parent.location.hostname;

      var imageURL = "https://ssl.google-analytics.com/collect?v=1&t=event"
                   + "&ec=" + encodeURIComponent(tracking_id)
                   + "&tid=" + account 
                   + "&z=" + z 
                   + "&cid=" + guid() 
                   + "&ea=" + window.parent.location.hostname;



    makeRequest(viewImageURL)
      .then(function () {
          makeRequest(imageURL)
      .then(function (status) {
      console.log(status.responseURL);
      })
      .catch(function (error) {
      console.log('Something went wrong', error);
      });
      })
      .catch(function (error) {
        console.log('Something went wrong', error);
      });
  }
  


  widgetlistener (event) {
    // console.log(event);
    let WIDGETORIGIN = window.location.origin;

    /*ie for some reason sends about when there is no iframe context*/
    if (event.origin !== WIDGETORIGIN && event.origin !== "about:" ) {
      return;
    }
  
    try {
      let response = JSON.parse(event.data);
      
      if (response['type'] == "resize") {
        let widgetNewHeight = response['newHeight'];
        document.getElementById(response['targetid']).setAttribute('height', Math.min(widgetNewHeight,1385) );
      }
    } catch (e) {}
  }

  widgetConstructor (iFrameId, src, preload = false, defer = false, prefetch = false ){
    return new Promise(resolve => {

        // resolve the promise immediately if no url is provided

        if(!src){
          return resolve();
        }

        let iFrameHead = document.getElementById(iFrameId).contentWindow.document.head;

        // Prefetch dns for assets that are required for the page

        if(prefetch){
          let widgetPrefetch = document.createElement('link');
              widgetPrefetch.rel = 'dns-prefetch';
              widgetPrefetch.href = src;

              // Append and return on the prefech-dns directive
              iFrameHead.appendChild(widgetPrefetch);

              return resolve();
        }

        // Prioritize the loading of a script by directing the browser to prefetch the asset

        if(preload){
            let widgetPreload = document.createElement('link');
                widgetPreload.rel = 'preload';
                widgetPreload.href = src;
                widgetPreload.as = 'script';

                // Append the preload link
                iFrameHead.appendChild(widgetPreload);
        } 

        // Add script tags

        let widgetScript = document.createElement('script');
            widgetScript.type = 'text/javascript';
            widgetScript.src = src;

        if(preload){
          // defer doesn't mean what we think it does it is async and forces order
          widgetScript.defer = true;
        }

        // Append element and resolve promise
        if(defer){
            // delay the load of a script until after all other assets have loaded
            widgetScript.defer = true;

            let iFrameBody = document.getElementById(iFrameId).contentWindow.document.body;

            iFrameBody.appendChild(widgetScript);
        } else {
          iFrameHead.appendChild(widgetScript);
        }

        return resolve();
    });
  }

  widgetDivInjector (iFrameId, wtype, geographyname, geographytype, tokenid, title, displaycolumns, themecolor,styleid,period,periodtype, colors,charttype,classtype, county,usertoken) {
    return new Promise(resolve => {
      let widgetdiv = document.createElement('div');
          widgetdiv.id = wtype == 'trends' ? `aculistWidgetRoot` : wtype == 'kpi' ? 'aculistkpiWidgetRoot' : '';
          widgetdiv.className = 'aculistwidgetv1';
          widgetdiv.setAttribute("data-geographytype", geographytype);
          widgetdiv.setAttribute("data-geographyname", geographyname);
          widgetdiv.setAttribute("data-tokenid", tokenid);
          widgetdiv.setAttribute("data-title", title);
          widgetdiv.setAttribute("data-displaycolumns", displaycolumns);
          widgetdiv.setAttribute("data-themecolor", themecolor);
          widgetdiv.setAttribute("data-parentframeid", iFrameId);
          widgetdiv.setAttribute("data-styleid", styleid);
          if(county!="")
          {
          widgetdiv.setAttribute("data-county", county);
          }
       
          widgetdiv.setAttribute("data-usertoken", usertoken);

         if( wtype == 'trends')
          {
            widgetdiv.setAttribute("data-period", period);
            widgetdiv.setAttribute("data-periodtype", periodtype);
            widgetdiv.setAttribute("data-colors", colors);
            widgetdiv.setAttribute("data-charttype", charttype);
            widgetdiv.setAttribute("data-classtype", classtype);
          }

          let iFrameBody = document.getElementById(iFrameId).contentWindow.document.body;
          iFrameBody.appendChild(widgetdiv);
          resolve();
    })
  }

  injectCustomCSS (iFrameId,styleid){
    return new Promise(resolve => {    
    if(styleid!=String.Empty || styleid!=null)
    {
      let customstyles=document.getElementById(styleid);
      let iFrameHead = document.getElementById(iFrameId).contentWindow.document.body;
      iFrameHead.appendChild(customstyles);    
    }
      resolve();
  });
}

  injectIframe() {

    addEventListener("message", this.widgetlistener, false);

    this.selector.forEach((widgetselector, index) => {
      //const seed = Math.floor(Math.random() * 100000);
      const seed = uniqueId('aculistwidgetframe_');
      const iFrameId = `${seed}`;
      
      //console.log(`Step1: inject iframe - ${iFrameId}`);

      let dataset = widgetselector.dataset,
          geographytype = "geographytype" in dataset ? dataset.geographytype : "",
          geographyname = "geographyname" in dataset ? dataset.geographyname : "",
          divid = widgetselector.id,
          wtype = "widgettype" in dataset ? dataset.widgettype : "",
          cssurl = "cssurl" in dataset ? dataset.cssurl : "",
          tokenid = "tokenid" in dataset ? dataset.tokenid : "",
          title = "title" in dataset ? dataset.title : "",
          displaycolumns = "displaycolumns" in dataset ? dataset.displaycolumns : "",
          themecolor = "themecolor" in dataset ? dataset.themecolor : "",
          styleid = "styleid" in dataset ? dataset.styleid : "",
          period = "period" in dataset ? dataset.period : "",
          periodtype = "periodtype" in dataset ? dataset.periodtype : "",
          colors = "colors" in dataset ? dataset.colors : "",
          charttype = "charttype" in dataset ? dataset.charttype : "",
          classtype = "classtype" in dataset ? dataset.classtype : "",
          county = "county" in dataset ? dataset.county : "",
          usertoken = "usertoken" in dataset ? dataset.usertoken : "";

      //Create a division
        let iframe = document.createElement('iframe');
         // iframe.id = 'aculistwidgetframe' + seed;
           iframe.id = iFrameId;
          iframe.width = "100%";
         // iframe.height = "auto";         
          iframe.className = "aculistwidget";
          iframe.scrolling = "no";
          iframe.frameborder = "0";
          iframe.style.border = "none";        
          
         // iframe.style.overflow="hidden";

          iframe.onload = (e) => {
          //  setTimeout( function(){
              let trackableobject=usertoken!==""?usertoken:tokenid;

              //Call GA
              this.widgetTrackingGIF(trackableobject);
            
              //console.log('1.1', e);
              this.startEmbedProcess(iFrameId, wtype, geographyname, geographytype, tokenid, title, displaycolumns, themecolor,styleid,period,periodtype, colors,charttype,classtype, county,'usertoken');
         //   }.bind(this), 200 + index)
          }
        
      // Append iFrame to Body
      //document.getElementById(divid).appendChild(iframe);

      this.selector[index].appendChild(iframe);

    });
  }
}
